'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'

export default function CustomerLoginPage() {
  const [uid, setUid] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const router = useRouter()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      const response = await fetch('/api/auth/customer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ uid: uid.trim(), password }),
      })

      const data = await response.json()

      if (response.ok) {
        // Store token in localStorage
        localStorage.setItem('customer_token', data.token)
        localStorage.setItem('customer_user', JSON.stringify(data.user))
        
        // Redirect to dashboard
        router.push('/customer/dashboard')
      } else {
        setError(data.error || 'Giriş xətası')
      }
    } catch (error) {
      console.error('Login error:', error)
      setError('Bağlantı xətası')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" rel="stylesheet" />
      <div className="min-h-screen bg-gradient-to-br from-blue-900 via-blue-600 to-purple-600 flex items-center justify-center p-5">
        <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full">
          <div className="text-center mb-8">
            <i className="fas fa-user-circle text-5xl text-blue-600 mb-4"></i>
            <h1 className="text-2xl font-semibold text-black mb-2">Müştəri Girişi</h1>
            <p className="text-gray-600">Profilinizi redaktə etmək üçün giriş edin</p>
          </div>
          
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label htmlFor="uid" className="block text-sm font-medium text-gray-700 mb-2">
                Kart ID (UID)
              </label>
              <input
                type="text"
                id="uid"
                value={uid}
                onChange={(e) => setUid(e.target.value.toUpperCase())}
                placeholder="Kartınızın UID-ini daxil edin"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <p className="text-xs text-gray-500 mt-1">NFC kartınızın üzərindəki kod</p>
            </div>

            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                Şifrə
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Şifrənizi daxil edin"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            
            {error && (
              <div className={`mb-4 p-3 border rounded-lg flex items-center gap-2 ${
                error.includes('müddəti bitib') 
                  ? 'bg-orange-100 border-orange-400 text-orange-700' 
                  : 'bg-red-100 border-red-400 text-red-700'
              }`}>
                <i className={`fas ${
                  error.includes('müddəti bitib') ? 'fa-clock' : 'fa-exclamation-circle'
                }`}></i>
                <div>
                  <div className="font-medium">{error}</div>
                  {error.includes('müddəti bitib') && (
                    <div className="text-sm mt-1">
                      Hesabınızın müddətini uzatmaq üçün admin ilə əlaqə saxlayın.
                    </div>
                  )}
                </div>
              </div>
            )}
            
            <button 
              type="submit" 
              disabled={loading}
              className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Giriş edilir...
                </>
              ) : (
                <>
                  <i className="fas fa-sign-in-alt"></i>
                  Giriş
                </>
              )}
            </button>
          </form>
          
          <div className="mt-6 text-center space-y-2">
            <p className="text-sm text-gray-600">
              Şifrənizi unutdunuz? Admin ilə əlaqə saxlayın
            </p>
            <Link href="/" className="text-blue-600 hover:text-blue-800 text-sm flex items-center justify-center gap-2">
              <i className="fas fa-arrow-left"></i> Ana səhifəyə qayıt
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}